
import { ModuleInitializer, ModuleInitializerHelper } from '@workflow/helper/module-initializer/module-initializer.class';
import { OlaCustomFunctionsService } from './services/logic-functions/custom-functions.service';
import { OlaOnChangeFunctionsService } from './services/logic-functions/on-change-functions.service';
import { OlaOnClickFunctionsService } from './services/logic-functions/on-click-functions.service';
import { OlaVisibleFunctionsService } from './services/logic-functions/visible-functions.service';
import { OlaCardValidationFunctionsService } from './services/validations/card-validation-functions.service';
import { OlaFieldValidationFunctionsService } from './services/validations/field-validation-functions.service';
import { OlaPageValidationFunctionsService } from './services/validations/page-validation-functions.service';

const OLA = 'ola';

export class OlaModuleInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static init(routeInit?: { PageComponent: any; guard: any }): ModuleInitializer {
    const initializer = new ModuleInitializerHelper()
      .AddValidationService(OlaPageValidationFunctionsService)
      .AddValidationService(OlaCardValidationFunctionsService)
      .AddValidationService(OlaFieldValidationFunctionsService)

      .AddLogicService(OlaCustomFunctionsService)
      .AddLogicService(OlaVisibleFunctionsService)
      .AddLogicService(OlaOnChangeFunctionsService)
      .AddLogicService(OlaOnClickFunctionsService);

    if (routeInit) {
      initializer.AddRoute('', routeInit.PageComponent, routeInit.guard, OLA);
    }
    return initializer;
  }
}
